import { render, staticRenderFns } from "./AdminSearchClientModal.vue?vue&type=template&id=045774fc"
import script from "./AdminSearchClientModal.vue?vue&type=script&lang=js"
export * from "./AdminSearchClientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports